/**
 * 将数字格式化为欧元货币格式 (EUR) 用的之前的名字，没有改变
 * @param {number} num - 需要格式化的数字
 * @returns {string} 格式化后的货币字符串，例如 "€1,234.56"
 */
export const formatToUKCurrency = (num) => {
  // 处理无效输入，包括 0, null, undefined, NaN 等情况
  if (!num || isNaN(num)) {
    return '€0.00';
  }

  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};
